import { flexColumn, flexStyle } from 'components/common/Common';
import { motion } from 'framer-motion/dist/framer-motion';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { CirclePointerIcon } from '../Home.style';

const EmptyLeg = styled(motion.div)`
  --card-min-width: 279px;

  min-width: var(--card-min-width);
  width: 307px;
  max-width: 307px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 45.79%, rgba(44, 143, 234, 0.32) 100%);
  border-radius: 8px;
  //! for border-radius to work
  overflow: hidden;

  @media (max-width: 757px) {
    width: var(--card-min-width);
  }
`;

const EmptyLegLink = styled(Link)`
  position: relative;
  cursor: pointer;
  line-height: normal;
  & > img {
    min-width: var(--card-min-width);
    width: 100%;
    height: 160px;
    object-fit: cover;
  }
  @media (max-width: 757px) {
    min-width: var(--card-min-width);
    height: 224px;
    & > img {
      filter: brightness(0.6);
      position: absolute;
      height: 149px;
    }
  }
`;

const CardContent = styled(motion.div)`
  padding: 16px;
  color: #07080a;
  font-weight: var(--fw-bold);
`;

const CardBody = styled(CardContent)`
  position: relative;
  font-size: var(--fs-800);
  @media (max-width: 757px) {
    background-color: transparent;
    z-index: 2;
    color: #fff;
    font-size: 18px;
    padding-top: 32px;
    padding-bottom: 32px;

    height: 149px;
  }
`;

const Location = styled.div`
  ${flexColumn}
  ${flexGap('8px')}
`;

const FirstCity = styled.div`
  ${flexStyle}
  align-items: center;
  ${flexGap('8px')}
`;

const DateBody = styled.div`
  margin-top: 16px;
  font-weight: var(--fw-normal);
  font-size: var(--fs-400);
`;

const CardFooter = styled(CardContent)`
  font-size: var(--fs-700);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PlaneIcon = styled.img`
  display: inline-block;
  transform: rotate(90deg);
  width: 24px;

  @media (max-width: 757px) {
    filter: invert(100%);
  }
`;

const Price = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(vw(4))};

  & > img {
    display: inline-block;
    width: 40px;
    height: 40px;
  }

  & > div {
    display: inline-flex;
    flex-direction: column;
    ${flexGap('4px')};

    & > span:first-child {
      font-weight: var(--fw-normal);
      font-size: var(--fs-400);
    }
  }

  @media (max-width: 757px) {
    & > img {
      width: 32px;
      height: 32px;
    }
  }
`;

const HRContainer = styled(CardContent)`
  padding-top: 0;
  padding-bottom: 0;
  @media (max-width: 757px) {
    display: none;
  }
`;

const HR = styled.hr`
  border: 0.5px solid rgba(7, 19, 33, 0.2);
`;

const variant = {
  hover: {
    y: -8,
    boxShadow: '0px 4px 16px rgba(77, 100, 126, 0.4)',
    transition: { duration: 0.5 },
  },
};

const EmptyLegLinkComponent = forwardRef((props, ref) => <EmptyLegLink ref={ref} {...props} />);
EmptyLegLinkComponent.displayName = 'EmptyLegLinkComponent';
const MotionLinkComponent = motion(EmptyLegLinkComponent);

const Card = ({ item }) => {
  return (
    <EmptyLeg variants={variant} whileHover="hover">
      <MotionLinkComponent
        to={{
          pathname: item.path,
          state: item,
        }}
      >
        <img src={item.picture} alt="city" />
        <CardBody>
          <Location>
            <FirstCity>
              <span>{item.startCity}</span>
              <PlaneIcon
                src={'/imgs/svg/home/raw-plane-icon.svg'}
                alt="plane-icon"
                height={24}
                width={24}
              />
            </FirstCity>

            <span>{item.endCity}</span>
          </Location>

          <DateBody>
            <span>{item.startDate}</span> - <span>{item.endDate}</span>
          </DateBody>
        </CardBody>
        <HRContainer>
          <HR />
        </HRContainer>
        <CardFooter>
          <Price>
            <img
              src={'/imgs/svg/home/raw-plane-icon.svg'}
              alt="plane-icon"
              height={40}
              width={40}
            />
            <div>
              <span>From</span>
              <span className="price"> $ {item.price}</span>
            </div>
          </Price>

          <button>
            <CirclePointerIcon />
          </button>
        </CardFooter>
      </MotionLinkComponent>
    </EmptyLeg>
  );
};

export default Card;
